import React, {useEffect, useState} from 'react';
import {useList} from "react-use";
import lodash from "lodash";
import Checkbox from "../../../../../components/checkbox";
import {Collapse} from 'react-collapse';

function ScoringRunner(props) {
    const [isOpened, setIsOpened] = useState(false);
    const {selected} = props;
    const [listScoring, listScoringHelper] = useList([
        {
            value: 0,
            name: '得点圏走者なし',
            checked: false,
        },
        {
            value: 1,
            name: '得点圏走者あり',
            checked: false,
        },
    ]);
    useEffect(() => {
        if(selected.length === 0) return;
        selected.map(item => {
            const index = listScoring.findIndex(i => i.value === item);
            listScoring[index].checked = true;
        })
    },[selected])
    useEffect(() => {
        props.onChange(lodash.map(lodash.filter(listScoring,['checked', true]), 'value'));
    }, [listScoring]);

    const onChange = (item, index) => {
      listScoringHelper.updateAt(index,{...item,checked: !item.checked});
    };

    return (
        <div className='group-filter-item'>
           <div className={'open-collapse'}>
               <div className='toggle-collapse' onClick={()=> setIsOpened(!isOpened)}>
                   <h4>得点圏走者</h4>
                   <img src="/img/chevron_down_24px.svg" alt="arrow-down" style={{transform:isOpened === true && 'rotate(180deg)'}}/>
               </div>
               <Collapse isOpened={isOpened}>
                   <div className='d-flex-align-center' style={{ display: "flex"}}>
                       {listScoring.map((item,index) => {
                           return <div key={item.value} className={'search-main-advanced-checkbox'}>
                               <label>
                                   <Checkbox onChange={() => onChange(item, index)} value={item.value} checked={item.checked}/>
                                   {item.name}
                               </label>
                           </div>
                       })}
                   </div>
               </Collapse>
           </div>
            <div className={'close-collapse'}>
                <div className='toggle-collapse' onClick={()=> setIsOpened(!isOpened)}>
                    <h4>得点圏走者</h4>
                </div>

                    <div className='d-flex-align-center' style={{ display: "flex"}}>
                        {listScoring.map((item,index) => {
                            return <div key={item.value} className={'search-main-advanced-checkbox'}>
                                <label>
                                    <Checkbox onChange={() => onChange(item, index)} value={item.value} checked={item.checked}/>
                                    {item.name}
                                </label>
                            </div>
                        })}
                    </div>

            </div>
        </div>
    )
}

export default ScoringRunner;
